import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from 'auth/components/auth/auth.component';
import { ForgotComponent } from 'auth/components/forgot/forgot.component';
import { NoAuthGuard } from 'core/guards/no-auth.guard';
import { RecoveryInviteGuard } from 'core/guards/recovery-invite.guard';
import { RegistrationInviteGuard } from 'core/guards/registration-invite.guard';
import { LoginComponent } from './components/login/login.component';
import { RecoveryComponent } from './components/recovery/recovery.component';
import { RegistrationComponent } from './components/registration/registration.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    component: AuthComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        component: LoginComponent,
        data: { title: 'PAGE_TITLES.login' },
      },
      {
        path: 'forgot',
        component: ForgotComponent,
        data: { title: 'PAGE_TITLES.recovery_request' },
      },
      {
        path: 'recovery',
        component: RecoveryComponent,
        canActivate: [RecoveryInviteGuard, NoAuthGuard],
        data: { title: 'PAGE_TITLES.recovery' },
      },
      {
        path: 'registration/:token',
        component: RegistrationComponent,
        canActivate: [RegistrationInviteGuard],
        data: { title: 'PAGE_TITLES.registration' },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {
}
